module.exports = __webpack_public_path__ + "img/FleetManager_einfarbig_RGB.0da9fc90.svg";